// extracted by mini-css-extract-plugin
module.exports = {"root":"popover-content-close_root__xrjn7","highlight":"popover-content-close_highlight__eTpjU"};